import { useRef, useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import MainView from "./MainView";
import SearchView from "./SearchView";
import { Container, Inner } from "./styles";

export type ToolbarProps = {};

const Toolbar: React.FC<ToolbarProps> = (props) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Container>
      <SwitchTransition>
        <CSSTransition
          key={searchOpen ? "search" : "default"}
          classNames="animation"
          nodeRef={innerRef}
          addEndListener={(done) => {
            innerRef.current?.addEventListener("transitionend", done, false);
          }}
          mountOnEnter
          unmountOnExit
        >
          <Inner ref={innerRef}>
            {searchOpen ? (
              <SearchView closeSearch={() => setSearchOpen(false)} />
            ) : (
              <MainView openSearch={() => setSearchOpen(true)} />
            )}
          </Inner>
        </CSSTransition>
      </SwitchTransition>
    </Container>
  );
};

export default Toolbar;
